import "../css/layouts.css";
import Navigation from "../Navigation";
import Holidays from 'date-holidays';
import {
    GovAccordionItem,
    GovBreadcrumbs,
    GovButton, GovFormCheckbox, GovFormControl, GovFormGroup,
    GovFormInput, GovFormLabel, GovFormMessage, GovFormMultiSelect, GovFormRadio, GovFormSelect,
    GovIcon, GovMessage, GovModal, GovPrompt, GovSkeleton, GovSpacer
} from "@gov-design-system-ce/react";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import Select, {components} from "react-select";
import {MenuList} from "./MenuList";
import {checkIfDayIsWeekendOrHoliday, convertIsoToLocalDateTime} from "../utils/utils";
import RichTextEditor from "../../pageElements/RichTextEditor";

export function NewConsultationContent() {
    const { townId } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const externalConsultation = queryParams.get('external') === 'true';
    const jwt = localStorage.getItem('jwt');
    const [town, setTown] = useState();
    const [rcPeople, setRcPeople] = useState([]);
    const [externalPersons, setExternalPersons] = useState([]);

    const [startDateInvalid, setStartDateInvalid] = useState(true)
    const [endDateInvalid, setEndDateInvalid] = useState(true)
    const [agreedPointsInvalid, setAgreedPointsInvalid] = useState(true)
    const [townPersonCheckedArrayInvalid, setTownPersonCheckedArrayInvalid] = useState(true)
    const [selectedExternalPersonsInvalid, setExternalSelectedPersonsInvalid] = useState(true)
    const [nextStepsInvalid, setNextStepsInvalid] = useState(true)
    const [openPointsInvalid, setOpenPointsInvalid] = useState(true)
    const [ratingInvalid, setRatingInvalid] = useState(true)
    const [resultInvalid, setResultInvalid] = useState(true)
    const [townInLoggedUserRc, setTownInLoggedUserRc] = useState(false)

    const collective = townId && townId.length > 6;

    function checkErrors() {
        let ready = !startDateInvalid && !endDateInvalid && !agreedPointsInvalid &&
            (externalConsultation || !townPersonCheckedArrayInvalid) &&
            !selectedExternalPersonsInvalid && !ratingInvalid && !resultInvalid &&
            !townInLoggedUserRc &&
            (!externalConsultation || town);
        setConsultationValid(ready)
        console.log([town, startDateInvalid, endDateInvalid, agreedPointsInvalid, townPersonCheckedArrayInvalid, selectedExternalPersonsInvalid, ratingInvalid, resultInvalid])
    }

    useEffect(() => {
        checkErrors()
    }, [town, startDateInvalid, endDateInvalid, agreedPointsInvalid, townPersonCheckedArrayInvalid, selectedExternalPersonsInvalid, ratingInvalid, resultInvalid, townInLoggedUserRc]);

    const [consultationValid, setConsultationValid] = useState(false)

    function fetchExternalPeople() {
        fetch(process.env.REACT_APP_API_URL+"/externalPersons", {
            headers: {
                'Authorization': `Bearer ${jwt}`
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(jsonData => {
                setExternalPersons(jsonData)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    };

    useEffect(() => {
        const fetchData = () => {
            fetch(process.env.REACT_APP_API_URL+`/towns/${townId.length > 6 ? "collective/" : ""}`+ townId, {
                headers: {
                    'Authorization': `Bearer ${jwt}`
                }
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(jsonData => {
                    setTown(jsonData)
                    fetchPeopleData(jsonData.regionalCenter.id)
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        };
        const fetchPeopleData = (regionalCenterId) => {
            fetch(process.env.REACT_APP_API_URL+"/rc/"+ regionalCenterId +"/employees", {
                headers: {
                    'Authorization': `Bearer ${jwt}`
                }
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(jsonData => {
                    setRcPeople(jsonData)
                    console.log(jsonData)
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        };

        fetchExternalPeople()
        if (townId) {
        fetchData();
        }
    }, []);

    function postNewConsultation(townId) {
        if (consultationValid) {
            return fetch(process.env.REACT_APP_API_URL + "/town/" + townId + "/preProjectConsultations", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwt}`
                },
                body: JSON.stringify({
                    "townId": parseInt(townId),
                    "start": startOfConsultation,
                    "end": endOfConsultation,
                    "agreedPoints": agreedPoints,
                    "actionPlan": nextSteps,
                    "openPoints": openPoints,
                    "rating": rating,
                    "result": resultOfConsultation,
                    "regionalCenterParticipants": externalConsultation ? [localStorage.getItem("userId")] : townPersonCheckedArray,
                    "externalParticipants": selectedExternalPersons,
                    "isExternal": externalConsultation
                })
            })
        }
    }
    function postNewExternalPerson() {
        return fetch(process.env.REACT_APP_API_URL+ "/externalPersons", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                "firstname": personName,
                "lastname": personSurname,
                "roleDescription": personRoleDescription,
                "institution": personOrganization,
                "role": personRole,
                "email": personEmail,
                "phone": personTelephone
            })
        })
            .then(response => {
                if (response.ok) {
                    return 'Request successful';
                } else {
                    throw new Error('Request failed');
                }
            })
            .catch(error => {
                return error.message;
            });
    }


    const [townPersonCheckedArray, setTownPersonCheckedArray] = useState([]);

    const handleTownPersonChange = (id) => {
        let newArray = [...townPersonCheckedArray];

        if (newArray.includes(id)) {

            newArray = newArray.filter(e => e !== id);
        } else {

            newArray.push(id);
        }
        newArray.length === 0 ? setTownPersonCheckedArrayInvalid(true) : setTownPersonCheckedArrayInvalid(false)

        setTownPersonCheckedArray(newArray);
    };

    const [resultOfConsultation, setResultOfConsultation] = useState('Dohoda o spolupráci obce s RC');
    const handleRadioChange = (event) => {
        if (event.target.value === "") {
            setResultInvalid(true)
        } else {
            setResultInvalid(false)
        }
        setResultOfConsultation(event.target.value);
    }

    const [personName, setPersonName] = useState('');
    const [personSurname, setPersonSurname] = useState('');
    const [personTelephone, setPersonTelephone] = useState('');
    const [personEmail, setPersonEmail] = useState('');
    const [personRole, setPersonRole] = useState('');
    const [personOrganization, setPersonOrganization] = useState('');
    const [personRoleDescription, setPersonRoleDescription] = useState('');
    const [contactPerson, setContactPerson] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [startOfConsultation, setStartOfConsultation] = useState('');
    const [endOfConsultation, setEndOfConsultation] = useState('');
    const [lengthOfConsultationHours, setLengthOfConsultationHours] = useState('0');
    const [lengthOfConsultationMinutes, setLengthOfConsultationMinutes] = useState('0');


    const [lengthOfConsultation, setLengthOfConsultation] = useState('');
    const [openPoints, setOpenPoints] = useState('');
    const [nextSteps, setNextSteps] = useState('');
    const [agreedPoints, setAgreedPoints] = useState('');
    const [rating, setRating] = useState('');
    let navigate = useNavigate();

    const [personArray, setPersonArray]=useState([
    ])
    function addPreProjectConsultation(){
        if(externalConsultation){
            postNewConsultation(townId).then(() => {navigate(`/new-consultation/external`)
            })}
        else {
            postNewConsultation(townId).then(response => {
                response.json()
                if (response.status === 409) {
                    navigate(`/towns/${townId.length > 6 ? "collective/" : ""}detail/${townId}?collision=true`);
                } else {
                    navigate(`/towns/${townId.length > 6 ? "collective/" : ""}detail/${townId}`);
                }
            });
        }
    }
    function addPerson(){
        if (newPersonValid) {
            let newItem = {
                id: crypto.randomUUID(),
                name: personName,
                surname: personSurname,
                telephone: personTelephone,
                organization: personOrganization,
                email: personEmail,
                role: personRole
            }
            postNewExternalPerson().then(() => {
                fetchExternalPeople();
            });

            setPersonName("")
            setPersonSurname("")
            setPersonTelephone("")
            setPersonEmail("")
            setPersonOrganization("")
            setPersonRoleDescription("")
            setPersonRole("STATUTORY_DEPUTY")
            closeModal()
        }
    }

    const [nameInvalid, setNameInvalid] = useState(true)
    const [surnameInvalid, setSurnameInvalid] = useState(true)
    const [phoneInvalid, setPhoneInvalid] = useState(true)
    const [emailInvalid, setEmailInvalid] = useState(true)
    const [institutionInvalid, setInstitutionInvalid] = useState(true)
    const [roleInvalid, setRoleInvalid] = useState(true)

    const [smallerDate, setSmallerDate] = useState(false)

    const [newPersonValid, setNewPersonValid] = useState(false)

    function checkErrorsPerson() {
        let ready = !nameInvalid && !surnameInvalid && !phoneInvalid && !emailInvalid && !institutionInvalid && !roleInvalid
        setNewPersonValid(ready)
    }

    useEffect(() => {
        checkErrorsPerson()
    }, [nameInvalid, surnameInvalid, phoneInvalid, emailInvalid,  institutionInvalid, roleInvalid]);


    function deletePerson(uuid){
        const updatedArray = []
    }
    function openModal(){
        console.log(newPersonValid)
        setModalOpen(true)
    }
    function closeModal(){
        setModalOpen(false)
    }

    const handlePersonNameChange = (event) => {
        if (event.target.value === "") {
            setNameInvalid(true)
        } else {
            setNameInvalid(false)
        }
        setPersonName(event.target.value);
    };
    const handlePersonSurnameChange = (event) => {
        if (event.target.value === "") {
            setSurnameInvalid(true)
        } else {
            setSurnameInvalid(false)
        }
        setPersonSurname(event.target.value);
    };
    const handlePersonTelephoneChange = (event) => {
        if (!/^\d{9}$/.test(event.target.value)) {
            setPhoneInvalid(true)
        } else {
            setPhoneInvalid(false)
        }
        setPersonTelephone(event.target.value);
    };
    const handlePersonEmailChange = (event) => {
        if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(event.target.value.toLowerCase())) {
            setEmailInvalid(true)
        } else {
            setEmailInvalid(false)
        }
        setPersonEmail(event.target.value);
    };
    const handlePersonOrganizationChange = (event) => {
        if (event.target.value === "") {
            setInstitutionInvalid(true)
        } else {
            setInstitutionInvalid(false)
        }
        setPersonOrganization(event.target.value);
    };
    const handlePersonRoleDescriptionChange = (event) => {
        setPersonRoleDescription(event.target.value);
    };
    const handlePersonRoleChange = (event) => {
        if (event.target.value === "") {
            setRoleInvalid(true)
        } else {
            setRoleInvalid(false)
        }
        setPersonRole(event.target.value);
    };
    const handleContactPersonChange = (event) => {
        setContactPerson(event.target.value);
    };
    const [chosenDayIsWeekendOrHoliday, setChosenDayIsWeekendOrHoliday] = useState(false);
    const handleStartOfConsultationChange = (event) => {
        let chosenDay = new Date(event.target.value);

        if (event.target.value === "") {
            setEndOfConsultation('')
            setLengthOfConsultationHours(0)
            setLengthOfConsultationMinutes(0)
            setStartDateInvalid(true)
        } else if (checkIfDayIsWeekendOrHoliday(chosenDay)) {
            setChosenDayIsWeekendOrHoliday(true)
        } else {
            setChosenDayIsWeekendOrHoliday(false)
            setStartDateInvalid(false)
        }
        setStartOfConsultation(event.target.value);
    }
    const [confirmLengthOfConsultationModalOpen, setConfirmLengthOfConsultationModalOpen] = useState(false)
    const [wasTheConfirmationLengthDialogOpen, setWasTheConfirmationLengthDialogOpen] = useState(false)
    const [pendingHoursOfConsultation, setPendingHoursOfConsultation] = useState()
    const handleHoursOfConsultationChange = (event) => {
        setPendingHoursOfConsultation(event.target.value);
        if (event.target.value > 2 && !wasTheConfirmationLengthDialogOpen) {
            setConfirmLengthOfConsultationModalOpen(true)
        }
        else if(event.target.value <= 2 && wasTheConfirmationLengthDialogOpen) {
            setWasTheConfirmationLengthDialogOpen(false)
            setLengthOfConsultationHours(event.target.value)
        }
        else {
            setLengthOfConsultationHours(event.target.value);
        }
    }
    const handleMinutesOfConsultationChange = (event) => {
        setLengthOfConsultationMinutes(event.target.value);
    }


    const handleEndOfConsultationChange = (hours, minutes) => {
        hours= parseInt(hours)
        minutes = parseInt(minutes)
        if (startOfConsultation !== "" && hours >= 0) {
            const start = new Date(startOfConsultation);


            const end = new Date(startOfConsultation);
            console.log(start,end)

            end.setHours(end.getHours() + hours, end.getMinutes() + minutes, 0, 0); // Nastaví hodiny a minuty
            console.log(end.getHours())
            console.log(start>=end)
            if (start >= end || end.getHours() > 20 || end.getHours() < 7) {
                setEndDateInvalid(true);
                setEndOfConsultation(`${end.getFullYear()}-${String(end.getMonth() + 1).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')}T${String(end.getHours()).padStart(2, '0')}:${String(end.getMinutes()).padStart(2, '0')}`);
            } else {
                setEndDateInvalid(false);
                setEndOfConsultation(`${end.getFullYear()}-${String(end.getMonth() + 1).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')}T${String(end.getHours()).padStart(2, '0')}:${String(end.getMinutes()).padStart(2, '0')}`);
            }
            console.log(startOfConsultation)
            console.log(`${end.getFullYear()}-${String(end.getMonth() + 1).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')}T${String(end.getHours()).padStart(2, '0')}:${String(end.getMinutes()).padStart(2, '0')}`);

        }
        else {
            setEndDateInvalid(true);
        }
    };

    const handleOpenPointsChange = (event) => {
        if (event.target.value === "") {
            setOpenPointsInvalid(true)
        } else {
            setOpenPointsInvalid(false)
        }
        setOpenPoints(event.target.value);
    }
    const handleAgreedPointsChange = (event) => {
        if (event.target.value === "") {
            setAgreedPointsInvalid(true)
        } else {
            setAgreedPointsInvalid(false)
        }
        setAgreedPoints(event.target.value);
    }
    const checkAgreedPoints = () => {
        console.log(agreedPoints)
        if (agreedPoints === "<p><br></p>") {
            setAgreedPointsInvalid(true)
        } else {
            setAgreedPointsInvalid(false)
        }
    }
    useEffect(() => {
        checkAgreedPoints()
    }, [agreedPoints]);
    const handleNextStepsChange = (event) => {
        if (event.target.value === "") {
            setNextStepsInvalid(true)
        } else {
            setNextStepsInvalid(false)
        }
        setNextSteps(event.target.value);
    }

    const handleRatingChange = (event) => {
        if (event.target.value === "") {
            setRatingInvalid(true)
        } else {
            setRatingInvalid(false)
        }
        setRating(event.target.value);
    };
    const [selectedExternalPersons, setSelectedExternalPersons] = useState([]);
    const handleSelectExternalPersonsChange = (event) => {

        const newSelectedExternalPersons = Array.from(event.detail.value, option => parseInt(option.value));
        newSelectedExternalPersons.length === 0 ? setExternalSelectedPersonsInvalid(true) : setExternalSelectedPersonsInvalid(false)
        setSelectedExternalPersons(newSelectedExternalPersons);

    };

    const customStyles = {
        dropdownIndicator: (styles, state) => ({
            ...styles,
            width: "28px",
            marginRight: "5px",
            "&:hover": {
                color: "#686868"
            },
            color: state.isFocused ? "#686868" : "#686868",
            fill: "red"
        }),
        option: (styles, state) => ({
            ...styles,
            cursor: 'pointer',
        }),
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            cursor: 'pointer',
            borderRadius: '3px',
            "&:hover": {
                borderColor: "#2362a2"
            },
            borderColor: '#686868',
            minHeight: '32px',
            height: '32px',
            boxShadow: state.isFocused ? null : null,
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            color: '#686868',
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            fontSize: '14px',
            padding: '0 8px',
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
            color: '#686868',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: '#686868',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '32px',
        }),
    };

    const [villages, setVillages] = useState([])
    const [userVillages, setUserVillages] = useState([])

    const DropdownIndicator = (
        props
    ) => {
        return (
            <components.DropdownIndicator {...props}>
                <GovIcon type="basic" name="chevron-down"></GovIcon>
            </components.DropdownIndicator>
        );
    };

    const [selectedVillageId, setSelectedVillageId] = useState('')
    const [selectedVillageIdInvalid, setSelectedVillageIdInvalid] = useState(true)


    const handleVillageIdChange = (event) => {
        console.log(event)
        console.log(userVillages)
        if (userVillages.some(village => village.id === event.value)) {
            setTownInLoggedUserRc(true)
        }
        else{
            setTownInLoggedUserRc(false)
        }
        if (event.target === "") {
            setSelectedVillageIdInvalid(true)
        } else {
            setSelectedVillageIdInvalid(false)
        }
        let townFormat ={
            "id": event.value,
            "name": event.label.split('(')[0].trim()
        }
        setTown(townFormat);
        navigate(`/new-consultation/${event.value}?external=true`);
        console.log(townId)
        console.log(townFormat)
    };

    const fetchVillages = () => {
            fetch(process.env.REACT_APP_API_URL + "/towns/public", {
                headers: {
                    'Authorization': `Bearer ${jwt}`
                }
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(jsonData => {
                    setVillages(jsonData);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }

    const fetchUserVillages = () => {
            fetch(process.env.REACT_APP_API_URL + `/rc/${localStorage.getItem("RCid")}/towns`, {
                headers: {
                    'Authorization': `Bearer ${jwt}`
                }
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(jsonData => {
                    setUserVillages(jsonData);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }

    useEffect(() => {
        fetchVillages();
        if (externalConsultation){
            console.log("aaa")
            fetchUserVillages()
        }
    }, []);

    useEffect(() => {
        handleEndOfConsultationChange(lengthOfConsultationHours, lengthOfConsultationMinutes);
    }, [startOfConsultation, lengthOfConsultationHours, lengthOfConsultationMinutes]);


    return (
        <div>
            <Navigation active={"villages"}/>
            <div className="gov-container">
                <GovBreadcrumbs className="gov-breadcrumbs-login" wcag-label="You are in the following level">
                    <ul>
                        <li>
                            <GovIcon type="basic" name="chevron-right"></GovIcon>
                            <a href="/">Úvod</a></li>
                        <li>
                            <GovIcon type="basic" name="chevron-right"></GovIcon>
                            <a href="/towns/search">Obce</a></li>

                            {town && townId ? (
                                <li>
                                <GovIcon type="basic" name="chevron-right"></GovIcon>
                                    {externalConsultation ?
                                    <strong>{town.name} {townId.length > 6 && "(DSO)"}</strong>
                                    :
                                    <a href={`/towns/${townId.length > 6 ? "collective/" : ""}detail/${townId}`}>
                                        {town.name} {townId.length > 6 && "(DSO)"}
                                    </a>}

                                </li>
                            ) : (
                                !externalConsultation &&
                                    <GovSkeleton wcag-label="Loading content of page" variant="secondary" shape="text"
                                                 animation="progress" count="1" width="300px"
                                                 height="30px"></GovSkeleton>
                            )}

                        <li>
                            <GovIcon type="basic" name="chevron-right"></GovIcon>
                            {externalConsultation ? <strong>Externí konzultace</strong> :
                            <strong>Založení konzultace</strong>
                            }</li>
                    </ul>
                </GovBreadcrumbs>
                <div className="gov-container">
                    <div className="gov-container__content">

                        <div className="gov-title--beta">Založení konzultace {externalConsultation ? "(externí)" : ""}</div>

                        <div className="form-help-layout gov-tabs">
                            <div className="gov-tabs__content-holder ">
                                <div className="gov-tabs__content is-active" role="tabpanel">
                                    <form method="post">
                                        {externalConsultation &&
                                        <GovFormControl>
                                            <div>
                                                {villages.length !== 0 ?
                                                    <Select components={{MenuList, DropdownIndicator}}
                                                            options={villages.map(village => {
                                                                return {
                                                                    value: village.id,
                                                                    label: village.name + " (" + village.id + ")"
                                                                }
                                                            })} onChange={handleVillageIdChange}
                                                            placeholder={"Id obce"}
                                                            value={villages.map(village => {
                                                                return {
                                                                    value: village.id,
                                                                    label: village.name + " (" + village.id + ")"
                                                                }
                                                            }).find(village => village.value === selectedVillageId)}
                                                            styles={customStyles}
                                                            noOptionsMessage={() => "Nenašli jsme žádné obce"}/>
                                                    // <Select options={villages.map(village => {
                                                    //     return {value: village.id, label: village.name + " (" + village.id + ")"}
                                                    // })} onChange={handleVillageIdChange}
                                                    //         placeholder={"Id obce"}
                                                    //         value={villages.map(village => {
                                                    //             return {value: village.id, label: village.name + " (" + village.id + ")"}
                                                    //         }).find(village => village.value === selectedVillageId)}
                                                    //         components={{DropdownIndicator}}
                                                    //         styles={customStyles}
                                                    //         noOptionsMessage={() => "Nenašli jsme žádné obce"}
                                                    //
                                                    // />
                                                    : <GovSkeleton wcag-label="Loading content of page" variant="secondary"
                                                                   shape="text"
                                                                   animation="progress" count="1" width="300px"
                                                                   height="30px"></GovSkeleton>
                                                }
                                            </div>
                                            <GovFormLabel slot="top" size="m">Vyberte ID obce, ke které se konzultace
                                                vztahuje</GovFormLabel>
                                        </GovFormControl>
                                            }
                                        {(externalConsultation && townInLoggedUserRc) &&
                                            <GovMessage className="mb-10" variant="error">
                                                <GovIcon type="basic" name="info-circle" slot="icon"></GovIcon>
                                                <p>V seznamu obcí vašeho regionálního centra je obsažena zvolená obec. Externí konzultaci nelze založit.</p>
                                            </GovMessage>
                                        }
                                        {town && <h4>{collective ? "Název dobrovolného sdružení obcí" : "Název obce"}</h4>}
                                        {town && <p>{town.name}</p>}
                                        {town && <h4>{collective ? "Kód dobrovolného sdružení obcí" : "Kód obce"}</h4>}
                                        {town && <p>{town.id}</p>}
                                        <GovFormControl>
                                            <GovFormInput
                                                size="s" variant="secondary"
                                                input-type="datetime-local"
                                                value={startOfConsultation}
                                                onGov-input={handleStartOfConsultationChange}></GovFormInput>
                                            <GovFormLabel slot="top" size="s">Začátek konzultace*</GovFormLabel>
                                        </GovFormControl>
                                        {
                                            chosenDayIsWeekendOrHoliday &&
                                            <GovMessage className="mb-10" variant="error">
                                                <GovIcon type="basic" name="info-circle" slot="icon"></GovIcon>
                                                <p>Vybraný den je víkendem či státním svátkem, zvolte prosím jiný den.</p>
                                            </GovMessage>
                                        }
                                        <h4>Délka trvání konzultace</h4>

                                        <div className="consultation-time-select">
                                            <GovFormControl>
                                                <GovFormInput size="s" variant="secondary"
                                                              input-type="number"
                                                              value={lengthOfConsultationHours}
                                                              placeholder="0"
                                                              min="0"
                                                              max="8"
                                                              disabled={startOfConsultation === ""}
                                                              onGov-input={handleHoursOfConsultationChange}></GovFormInput>
                                                <GovFormLabel slot="top" size="s">Hodiny*</GovFormLabel>
                                            </GovFormControl>
                                            <GovFormControl className="w-70px">
                                                <GovFormSelect size="s" variant="secondary"
                                                               value={lengthOfConsultationMinutes}
                                                               disabled={startOfConsultation === ""}
                                                               onGov-change={handleMinutesOfConsultationChange}>
                                                    <option value="0">0</option>
                                                    {/*<option value="15">15</option>*/}
                                                    <option value="30">30</option>
                                                    {/*<option value="45">45</option>*/}
                                                </GovFormSelect>
                                                <GovFormLabel slot="top" size="s">Minuty*</GovFormLabel>
                                            </GovFormControl>

                                            <GovButton
                                                variant="primary"
                                                size="m"
                                                type="outlined"
                                                disabled={startOfConsultation === ""}
                                                onGov-click={() => {
                                                    setLengthOfConsultationHours(1);
                                                    setLengthOfConsultationMinutes(0);
                                                }}
                                            >
                                                1:00
                                            </GovButton>
                                            {/*<GovButton*/}
                                            {/*    variant="primary"*/}
                                            {/*    size="m"*/}
                                            {/*    type="outlined"*/}
                                            {/*    disabled={startOfConsultation === ""}*/}
                                            {/*    onGov-click={() => {*/}
                                            {/*        setLengthOfConsultationHours(1);*/}
                                            {/*        setLengthOfConsultationMinutes(15);*/}
                                            {/*    }}*/}
                                            {/*>*/}
                                            {/*    1:15*/}
                                            {/*</GovButton>*/}
                                            <GovButton
                                                variant="primary"
                                                size="m"
                                                type="outlined"
                                                disabled={startOfConsultation === ""}
                                                onGov-click={() => {
                                                    setLengthOfConsultationHours(1);
                                                    setLengthOfConsultationMinutes(30);
                                                }}
                                            >
                                                1:30
                                            </GovButton>
                                            {/*<GovButton*/}
                                            {/*    variant="primary"*/}
                                            {/*    size="m"*/}
                                            {/*    type="outlined"*/}
                                            {/*    disabled={startOfConsultation === ""}*/}
                                            {/*    onGov-click={() => {*/}
                                            {/*        setLengthOfConsultationHours(1);*/}
                                            {/*        setLengthOfConsultationMinutes(45);*/}
                                            {/*    }}*/}
                                            {/*>*/}
                                            {/*    1:45*/}
                                            {/*</GovButton>*/}
                                            <GovButton
                                                variant="primary"
                                                size="m"
                                                type="outlined"
                                                disabled={startOfConsultation === ""}
                                                onGov-click={() => {
                                                    setLengthOfConsultationHours(2);
                                                    setLengthOfConsultationMinutes(0);
                                                }}
                                            >
                                                2:00
                                            </GovButton>
                                        </div>
                                        <GovFormControl>
                                            <h4>Konec konzultace</h4>
                                            <p>{endOfConsultation ? convertIsoToLocalDateTime(endOfConsultation) : "Nejsou uvedené povinné položky"}</p>
                                        </GovFormControl>

                                        {!externalConsultation &&
                                        <GovFormControl>
                                            <GovFormGroup gap="m">
                                                {rcPeople
                                                    .sort((a, b) => a.lastname.localeCompare(b.lastname))
                                                    .map((person) => (
                                                    <GovFormCheckbox
                                                        size="m"
                                                        key={person.id}
                                                        value={person.id}
                                                        onGov-change={() => handleTownPersonChange(person.id)}
                                                        checked={townPersonCheckedArray.includes(person.id)}
                                                    >
                                                        <GovFormLabel size="m"
                                                                      slot="label">{person.firstname + " " + person.lastname}</GovFormLabel>
                                                    </GovFormCheckbox>
                                                ))}
                                            </GovFormGroup>
                                            <GovFormLabel slot="top" size="s">Účastníci (Regionální
                                                centrum)*</GovFormLabel>
                                        </GovFormControl>
                                        }

                                        <GovFormControl>
                                            <RichTextEditor value={agreedPoints} setValue={setAgreedPoints}/>
                                            {/*<GovFormInput size="s" variant="secondary"*/}
                                            {/*              input-type="text" multiline="true"*/}
                                            {/*              placeholder="Uveďte prosím dohodnuté body"*/}
                                            {/*              value={agreedPoints} onGov-input={handleAgreedPointsChange}>*/}
                                            {/*</GovFormInput>*/}
                                            <GovFormLabel slot="top" size="s">Dohodnuté body*</GovFormLabel>
                                        </GovFormControl>
                                        <GovSpacer size="xl"></GovSpacer>


                                        <GovFormControl>
                                            <RichTextEditor value={openPoints} setValue={setOpenPoints}/>
                                            {/*<GovFormInput size="s" variant="secondary"*/}
                                            {/*              input-type="text" multiline="true"*/}
                                            {/*              placeholder="Uveďte prosím otevřené body"*/}
                                            {/*              value={openPoints} onGov-input={handleOpenPointsChange}>*/}
                                            {/*</GovFormInput>*/}
                                            <GovFormLabel slot="top" size="s">Otevřené body</GovFormLabel>
                                        </GovFormControl>
                                        <GovSpacer size="xl"></GovSpacer>

                                        <GovFormControl>
                                            <RichTextEditor value={nextSteps} setValue={setNextSteps}/>
                                            {/*<GovFormInput size="s" variant="secondary"*/}
                                            {/*              input-type="text" multiline="true"*/}
                                            {/*              placeholder="Uveďte prosím další kroky/akční plán"*/}
                                            {/*              value={nextSteps} onGov-input={handleNextStepsChange}>*/}
                                            {/*</GovFormInput>*/}
                                            <GovFormLabel slot="top" size="s">Další kroky/akční plán</GovFormLabel>
                                        </GovFormControl>
                                        <GovSpacer size="xl"></GovSpacer>
                                        {/*<GovFormControl>
                                        <GovFormInput size="s" variant="secondary"
                                                      input-type="text" multiline="true"
                                                      placeholder="Uveďte prosím akční plán"
                                                      value={openPoints} onGov-input={handleOpenPointsChange}>
                                        </GovFormInput>
                                        <GovFormLabel slot="top" size="s">Akční plán*</GovFormLabel>
                                    </GovFormControl>
*/}
                                        <GovFormLabel className="mb-20" slot="top" size="xs">Další
                                            účastníci*</GovFormLabel>
                                        <GovFormMultiSelect size="m" onGov-change={handleSelectExternalPersonsChange}>
                                            {externalPersons.length > 0 &&
                                                <div>
                                                    {externalPersons.map((person) => (
                                                        <option key={person.id}
                                                                value={person.id}>{person.firstname + " " + person.lastname + " " + "(" + person.email + ")"}</option>
                                                    ))
                                                    }
                                                </div>
                                            }
                                        </GovFormMultiSelect>
                                        {/*{rcPeople.length > 0 &&*/}
                                        {/*    <div>*/}
                                        {/*        {rcPeople.map((person) => (*/}
                                        {/*            <div className="gov-layout gov-layout--ratio-1-2">*/}
                                        {/*                <div className="gov-layout__col gov-layout__col--pos-left">*/}
                                        {/*                    <p><b>Jméno a*/}
                                        {/*                        příjmení:</b> {person.name + " " + person.surname}*/}
                                        {/*                    </p>*/}
                                        {/*                    <p><b>Telefon:</b> {person.telephone}</p>*/}
                                        {/*                    <p><b>E-mail:</b> {person.email}</p>  <p>*/}
                                        {/*                    <b>Organizace:</b> {person.organization}</p>*/}
                                        {/*                    <p><b>Role:</b> {roleToText(person.role)}</p></div>*/}
                                        {/*                <div*/}
                                        {/*                    className="gov-layout__col gov-layout__col--pos-right gov-layout__col--spread-1">*/}
                                        {/*                    <GovButton variant="primary" size="m" type="solid"*/}
                                        {/*                               wcag-label="Open dialog box for more information"*/}
                                        {/*                               onGov-click={() => deletePerson(person.id)}>Odebrat*/}
                                        {/*                    </GovButton>*/}
                                        {/*                </div>*/}
                                        {/*            </div>*/}
                                        {/*        ))}*/}
                                        {/*        <hr/>*/}
                                        {/*    </div>*/}
                                        {/*}*/}

                                        <GovButton variant="primary" size="s" type="link"
                                                   wcag-label="Open dialog box for more information"
                                                   onGov-click={openModal}>+ Přidat další osobu
                                        </GovButton>
                                        <GovModal open={modalOpen} onGov-close={closeModal}
                                                  label="Přidání dalšího účastníka"
                                                  wcag-close-label="Close dialog box with more information">
                                            <GovFormControl>
                                                <GovFormInput value={personName} onGov-input={handlePersonNameChange}
                                                              size="s" variant="secondary"
                                                              input-type="text"
                                                              placeholder="Jméno"></GovFormInput>
                                                <GovFormLabel slot="top" size="s">Jméno*</GovFormLabel>
                                            </GovFormControl>
                                            <GovFormControl>
                                                <GovFormInput value={personSurname}
                                                              onGov-input={handlePersonSurnameChange}
                                                              size="s" variant="secondary"
                                                              input-type="text"
                                                              placeholder="Příjmení"></GovFormInput>
                                                <GovFormLabel slot="top" size="s">Příjmení*</GovFormLabel>
                                            </GovFormControl>
                                            <GovFormControl>
                                                <GovFormInput value={personTelephone}
                                                              onGov-input={handlePersonTelephoneChange}
                                                              size="s" variant="secondary"
                                                              input-type="text" placeholder="Telefon"></GovFormInput>
                                                <GovFormLabel slot="top" size="s">Telefon*</GovFormLabel>
                                            </GovFormControl>
                                            <GovFormControl>
                                                <GovFormInput value={personEmail} onGov-input={handlePersonEmailChange}
                                                              size="s" variant="secondary"
                                                              input-type="text" placeholder="E-mail"></GovFormInput>
                                                <GovFormLabel slot="top" size="s">E-mail*</GovFormLabel>
                                            </GovFormControl>
                                            <GovFormControl>
                                                <GovFormInput value={personOrganization}
                                                              onGov-input={handlePersonOrganizationChange}
                                                              size="s" variant="secondary"
                                                              input-type="text" placeholder="Organizace"></GovFormInput>
                                                <GovFormLabel slot="top" size="s">Organizace*</GovFormLabel>
                                            </GovFormControl>
                                            <div className="sfpi-title-section mt-20">Role
                                            </div>
                                            <GovFormControl>
                                                <GovFormGroup gap="s">
                                                    <GovFormRadio checked={personRole === "STATUTORY_DEPUTY"}
                                                                  onGov-change={handlePersonRoleChange}
                                                                  value="STATUTORY_DEPUTY" size="s"
                                                                  name="list-radio">
                                                        <GovFormLabel size="s" slot="label">Statutární
                                                            zástupce</GovFormLabel>
                                                    </GovFormRadio>
                                                    <GovFormRadio checked={personRole === "DELEGATE"}
                                                                  onGov-change={handlePersonRoleChange} value="DELEGATE"
                                                                  size="s"
                                                                  name="list-radio">
                                                        <GovFormLabel size="s" slot="label">Zmocněnec</GovFormLabel>
                                                    </GovFormRadio>
                                                    <GovFormRadio checked={personRole === "OBSERVER"}
                                                                  onGov-change={handlePersonRoleChange}
                                                                  value="OBSERVER" size="s" name="list-radio">
                                                        <GovFormLabel size="s" slot="label">Nahlížející
                                                            osoba</GovFormLabel>
                                                    </GovFormRadio>
                                                    <GovFormRadio checked={personRole === "CONTACT_PERSON"}
                                                                  onGov-change={handlePersonRoleChange}
                                                                  value="CONTACT_PERSON"
                                                                  size="s" name="list-radio">
                                                        <GovFormLabel size="s" slot="label">Kontaktní
                                                            osoba</GovFormLabel>
                                                    </GovFormRadio>
                                                    <GovFormRadio checked={personRole === "OTHER"}
                                                                  onGov-change={handlePersonRoleChange}
                                                                  value="OTHER"
                                                                  size="s" name="list-radio">
                                                        <GovFormLabel size="s" slot="label">Jiná
                                                        </GovFormLabel>
                                                    </GovFormRadio>

                                                </GovFormGroup>
                                                <div>
                                                    {personRole === "OTHER" &&
                                                        <div>
                                                            <GovFormControl>
                                                                <GovFormInput value={personRoleDescription}
                                                                              className="mt-10"
                                                                              onGov-input={handlePersonRoleDescriptionChange}
                                                                              size="s" variant="secondary"
                                                                              input-type="text"
                                                                              placeholder="Popis role"></GovFormInput>
                                                            </GovFormControl>
                                                        </div>
                                                    }
                                                </div>
                                            </GovFormControl>
                                            <div>
                                                {phoneInvalid &&
                                                    <GovMessage variant="error">
                                                        <GovIcon type="basic" name="info-circle" slot="icon"></GovIcon>
                                                        <p>Telefon musí obsahovat 9 číslic bez předvolby</p>
                                                    </GovMessage>
                                                }
                                            </div>
                                            <div>
                                                {!newPersonValid &&
                                                    <GovMessage variant="error">
                                                        <GovIcon type="basic" name="info-circle" slot="icon"></GovIcon>
                                                        <p>Nejsou vyplněny všechny povinné položky</p>
                                                    </GovMessage>}
                                            </div>
                                            <GovButton variant="primary" size="m" type="solid"
                                                       wcag-label="Open dialog box for more information"
                                                       onGov-click={addPerson} disabled={!newPersonValid}>Přidat
                                            </GovButton>

                                        </GovModal>


                                    </form>
                                    <GovFormControl>
                                        <div className="sfpi-title-section mt-20">Výsledek konzultace*
                                        </div>
                                        <GovFormGroup gap="s">
                                        <GovFormRadio onGov-change={handleRadioChange}
                                                          value="AGREEMENT" size="s"
                                                          name="list-radio">
                                                <GovFormLabel size="s" slot="label">Dohoda o spolupráci obce s
                                                    RC</GovFormLabel>
                                            </GovFormRadio>
                                            <GovFormRadio onGov-change={handleRadioChange}
                                                          value="NEXT_CONSULTATION_NEEDED" size="s"
                                                          name="list-radio">
                                                <GovFormLabel size="s" slot="label">Je nutná další
                                                    konzultace</GovFormLabel>
                                            </GovFormRadio>
                                            <GovFormRadio onGov-change={handleRadioChange}
                                                          value="NOT_INTERESTED" size="s"
                                                          name="list-radio">
                                                <GovFormLabel size="s" slot="label">Obec nemá zájem o
                                                    spolupráci</GovFormLabel>
                                            </GovFormRadio>
                                            <GovFormRadio onGov-change={handleRadioChange} value="OTHER"
                                                          size="s" name="list-radio">
                                                <GovFormLabel size="s" slot="label">Jiný výsledek</GovFormLabel>
                                            </GovFormRadio>

                                        </GovFormGroup>
                                    </GovFormControl>
                                    <GovFormControl>
                                        <GovFormSelect size="m" variant="secondary"
                                                       value={rating} onGov-change={handleRatingChange}>
                                            <option disabled="disabled" value="">Uveďte prosím hodnocení konzultace
                                                (jako ve škole)
                                            </option>
                                            <option value="1">1 - vynikající</option>
                                            <option value="2">2 - chvalitebná</option>
                                            <option value="3">3 - dobrá</option>
                                            <option value="4">4 - dostatečná</option>
                                            <option value="5">5 - nedostatečná</option>
                                        </GovFormSelect>
                                        <GovFormLabel slot="top" size="m">Hodnocení konzultace*</GovFormLabel>
                                    </GovFormControl>
                                    {!consultationValid &&
                                        <GovMessage variant="error"><p>Nejsou vyplněny všechny povinné položky nebo se
                                            konzultace uskutečnila mimo povolenou pracovní dobu.</p></GovMessage>}
                                    <GovButton wcag-label="What exactly happens when you click?" variant="primary"
                                               type="solid" size="m" onGov-click={addPreProjectConsultation}
                                               disabled={!consultationValid}>Odeslat
                                    </GovButton>

                                </div>
                                <div className="form-help-column gov-tabs__content " role="tabpanel">

                                    <h4>Nápověda</h4>

                                    <GovAccordionItem variant="primary" size="xs">
                                        <p><b>Statutární zástupce</b> - Právoplatný
                                            statutární zástupce obce. V
                                            portále můžee vystupovat jménem
                                            obce v plném rozsahu a může
                                            delegovat další role.</p>
                                        <p><b>Zmocněnec</b> - Tato osoba bude
                                            mít oprávnění spravovat projekty
                                            Dostupného bydlení v tomto
                                            portále v plném rozsahu, tzn.
                                            stejně jako Statutární Zástupce
                                            (vč. jmenováno dalších Zmocněnců).
                                        </p>
                                        <p><b>Nahlížející osoba</b> - Tato osoba
                                            má oproti Statutárnímu zástupci
                                            nebo Zmocněnci právo pouze
                                            nahlížet na všechna data v
                                            projektu. Nemůže dělat žádné
                                            aktivní operace, ale může být
                                            Kontaktní osobou.</p>
                                        <p><b>Kontaktní osoba</b> - Tato osoba
                                            bude primárním kontaktem pro
                                            jednání s Regionálním centrem.
                                            Může mít jakoukoliv roli (Statutární zástupce, Zmocněnec, nebo Nahlížející
                                            osoba).</p>

                                        <p slot="label">Role zainteresovaných osob</p>
                                    </GovAccordionItem>


                                </div>
                            </div>
                            <GovPrompt open={confirmLengthOfConsultationModalOpen} onGov-close={() => setConfirmLengthOfConsultationModalOpen(false)} label="Potvrzení">
                                Opravdu konzultace trvala 3 hodiny a více?
                                <GovButton
                                    variant="success" size="m"
                                    type="base"
                                    slot="actions"
                                    onGov-click={() => {
                                        setLengthOfConsultationHours(pendingHoursOfConsultation);
                                        setConfirmLengthOfConsultationModalOpen(false);
                                        setWasTheConfirmationLengthDialogOpen(true);
                                    }}
                                >
                                    Ano
                                </GovButton>
                                <GovButton
                                    variant="error" size="m" type="solid" slot="actions"

                                    onGov-click={() => setConfirmLengthOfConsultationModalOpen(false)}
                                >
                                    Ne
                                </GovButton>
                            </GovPrompt>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
